<template>
  <a-select
    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
    v-model:value="country"
    show-search
    :filter-option="false"
    :not-found-content="null"
    placeholder="Seleccionar zona horaria"
    @search="filterTimeZone"
    @dropdownVisibleChange="handleChange"
    @select="selectTimeZone"
  >
    <a-select-option v-for="item in zoneTimeBusines" :key="item.zone">
      ({{ item.utc }}) {{ item.zone }}
    </a-select-option>
  </a-select>
</template>

<script>
import { defineComponent, ref, computed, watch } from "vue";
import { useStore } from "vuex";
export default defineComponent({
  props: {
    code: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const country = ref(props.code);
    const showCountry = ref(false);
    const store = useStore();
    const zoneTime = computed(() => store.getters["getCompanyTimeZone"]);
    const zoneTimeBusines = ref([]);

    watch(zoneTime, (newValue) => {
      zoneTimeBusines.value = newValue;
    });

    return {
      country,
      zoneTime,
      zoneTimeBusines,
      showCountry,
    };
  },
  created() {
    this.$store.dispatch("fetchAllZoneTime");
  },
  methods: {
    filterTimeZone(value) {
      value = value.toLowerCase();
      this.zoneTimeBusines = this.zoneTime.filter((item) => {
        return item.zone.toLowerCase().includes(value);
      });
    },
    handleChange(data) {
      this.showCountry = data;
    },
    selectTimeZone(data) {
      this.$emit("onSelected", data);
    },
  },
});
</script>

<style lang="sass" scoped>
.flag
  width: 20px
  margin-bottom: 2px
  margin-right: 4px
</style>
